/* eslint-disable no-bitwise */
/* eslint-disable react/no-unused-class-component-methods */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable import/no-unresolved */
/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/no-unsafe-argument, max-params */
/* eslint-disable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any */
/* eslint-disable complexity, @typescript-eslint/no-unsafe-call */
/* eslint-disable no-unused-vars, @typescript-eslint/no-unsafe-member-access  */
/* eslint-disable @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-assignment  */
/* tslint:disable */
// @ts-nocheck
// What's with all the above disables?
//  this is what a legacy 7 year old codebase looks like.
import { listWithChildren } from '@elliemae/ds-shared';
import cn from 'classnames';
import { isEqualWith } from 'lodash-es';
import { Component } from 'react';
import {
  getItemByPath,
  getItemDepth,
  getItemOptions,
  getPathById,
  getRealNextPath,
  getSplicePath,
  moveItem,
  onDragEnd,
  onDragStart,
  onKeyDown,
  onMouseEnter,
  onMouseMove,
  onToggleCollapse,
  tryDecreaseDepth,
  tryIncreaseDepth,
} from './actions/index.js';
import NestableItem from './NestableItem.js';

const shallowCompare = (instance, nextProps, nextState) =>
  !isEqualWith(instance.props, nextProps) || !isEqualWith(instance.state, nextState);

class Nestable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      itemsOld: null,
      dragItem: null,
      isDirty: false,
      collapsedGroups: [],
      stopTrackingMouse: this.stopTrackMouse.bind(this),
      oldProps: props,
    };

    this.el = null;
    this.elCopyStyles = null;
    this.mouse = {
      last: { x: 0 },
      shift: { x: 0 },
    };

    this.dragApply = this.dragApply.bind(this);
    this.renderDragLayer = this.renderDragLayer.bind(this);
  }

  componentDidMount() {
    const { childrenProp } = this.props;
    let { items } = this.props;
    // make sure every item has property 'children'
    items = listWithChildren(items, childrenProp);
    this.setState({ items });
  }

  componentWillUnmount() {
    this.stopTrackMouse();
  }

  static getDerivedStateFromProps(props, state) {
    const { items: itemsNew, childrenProp } = props;
    const { stopTrackingMouse, oldProps } = state;

    if (shallowCompare({ props: oldProps, state: {} }, props, {})) {
      stopTrackingMouse();
      const extra = {};
      if (oldProps.collapsed !== props.collapsed) {
        extra.collapsedGroups = [];
      }
      return {
        items: listWithChildren(itemsNew, childrenProp),
        dragItem: null,
        isDirty: false,
        oldProps: props,
        ...extra,
      };
    }
    return null;
  }

  onDragStart = (e, item) => {
    onDragStart.call(this, e, item);
  };

  onDragEnd = (e, isCancel) => onDragEnd.call(this, e, isCancel);

  onMouseMove = (e) => onMouseMove.call(this, e);

  onMouseEnter = (e, item) => onMouseEnter.call(this, e, item);

  onToggleCollapse = (item, isGetter) => onToggleCollapse.call(this, item, isGetter);

  onKeyDown = (e) => onKeyDown.call(this, e);

  getDefaultItems = () => {
    const { items } = this.state;
    return items;
  };

  getPathById(id, items = this.getDefaultItems()) {
    return getPathById.call(this, id, items);
  }

  getItemByPath(path, items = this.getDefaultItems()) {
    return getItemByPath.call(this, path, items);
  }

  getItemDepth = (item) => getItemDepth.call(this, item);

  getSplicePath(path, options = {}) {
    return getSplicePath.call(this, path, options);
  }

  getRealNextPath(prevPath, nextPath) {
    return getRealNextPath.call(this, prevPath, nextPath);
  }

  getItemOptions() {
    return getItemOptions.call(this);
  }

  startTrackMouse = () => {
    document.addEventListener('mousemove', this.onMouseMove);
    document.addEventListener('mouseup', this.onDragEnd);
    document.addEventListener('keydown', this.onKeyDown);
  };

  stopTrackMouse = () => {
    document.removeEventListener('mousemove', this.onMouseMove);
    document.removeEventListener('mouseup', this.onDragEnd);
    document.removeEventListener('keydown', this.onKeyDown);
    this.elCopyStyles = null;
  };

  isCollapsed = (item) => {
    const { collapsed } = this.props;
    const { collapsedGroups } = this.state;
    return !!((collapsedGroups.indexOf(item.id) > -1) ^ collapsed);
  };

  checkFilterChildren = (items) =>
    items.find((current) => {
      const {
        element: { type },
        children,
      } = current;
      if (type === 'filter' && children.length > 0) return true;
      return this.checkFilterChildren(children);
    });

  dragRevert = () => {
    const { itemsOld } = this.state;

    this.setState({
      items: itemsOld,
      itemsOld: null,
      dragItem: null,
      isDirty: false,
    });
  };

  dragApply() {
    const { onChange } = this.props;
    const { items, isDirty, dragItem } = this.state;

    this.setState({
      itemsOld: null,
      dragItem: null,
      isDirty: false,
    });

    if (onChange && isDirty) onChange(items, dragItem);
  }

  tryIncreaseDepth(dragItem) {
    tryIncreaseDepth.call(this, dragItem);
  }

  tryDecreaseDepth(dragItem) {
    tryDecreaseDepth.call(this, dragItem);
  }

  moveItem({ dragItem, pathFrom, pathTo }, extraProps = {}) {
    moveItem.call(this, { dragItem, pathFrom, pathTo }, extraProps);
  }

  renderDragLayer() {
    const { group } = this.props;
    const { dragItem } = this.state;
    const el = document.querySelector(`.nestable-${group} .nestable-item-${dragItem.id}`);

    let listStyles = {};
    if (el) {
      listStyles.width = el.clientWidth;
    }
    if (this.elCopyStyles) {
      listStyles = {
        ...listStyles,
        ...this.elCopyStyles,
      };
    }

    const options = this.getItemOptions();

    return (
      <div className="nestable-drag-layer">
        <ol className="nestable-list" style={listStyles}>
          <NestableItem isCopy item={dragItem} options={options} />
        </ol>
      </div>
    );
  }

  render() {
    const { items, dragItem } = this.state;
    const { group, isAndItem, isOrItem, isDraggableItem, setDraggableItems, singleRow } = this.props;
    const options = this.getItemOptions();
    const childLength = items.length;
    let childClass = 'single';
    if (childLength === 0) childClass = 'empty';
    else if (childLength > 1) childClass = 'multiple';

    return (
      <div
        className={cn('nestable', `nestable-${group}`, {
          'is-drag-active': dragItem,
        })}
      >
        <ol className={`nestable-list nestable-group nestable-child-count-${childClass}`}>
          {items.map((item, i) => (
            <NestableItem
              key={item.id}
              index={i}
              isAndItem={isAndItem}
              isDraggableItem={isDraggableItem}
              isOrItem={isOrItem}
              item={item}
              options={options}
              setDraggableItems={setDraggableItems}
              singleRow={singleRow}
            />
          ))}
        </ol>
        {dragItem && this.renderDragLayer()}
      </div>
    );
  }
}

Nestable.defaultProps = {
  items: [],
  collapsed: false,
  group: Math.random().toString(36).slice(2),
  childrenProp: 'children',
  onChange: () => {},
};

export default Nestable;
